import { keepPreviousData, useQuery } from '@tanstack/react-query';

import * as api from './api';
import type { CockpitRange } from './types';

export function useDashboard() {
  return useQuery({ queryKey: ['command-center', 'dashboard'], queryFn: api.getDashboard });
}

export function useCockpit(range: CockpitRange) {
  return useQuery({
    queryKey: ['command-center', 'cockpit', range],
    queryFn: () => api.getCockpit(range),
    placeholderData: keepPreviousData,
  });
}

export function useChannels() {
  return useQuery({ queryKey: ['command-center', 'channels'], queryFn: api.getChannels });
}

export function useForecast() {
  return useQuery({
    queryKey: ['command-center', 'forecast'],
    queryFn: api.getForecast,
    retry: false, // 403 for non-finance roles — don't retry, just hide the card
  });
}

export function useGlobalSearch(q: string) {
  const term = q.trim();
  return useQuery({
    queryKey: ['command-center', 'search', term],
    queryFn: () => api.globalSearch(term),
    enabled: term.length > 0,
    placeholderData: keepPreviousData,
  });
}
